export const MainButton = ({
  type,
  onClick,
  disabled,
  children,
  className,
}) => {
  return (
    <button
      type={type}
      className={`btn btn-primary ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};
